<template>
  <div class="depend">
    <el-dialog title="建立依赖关系" :visible="visible" :show-close="false" width="80%">
      <el-row>
        <h3>实例基本信息</h3>
        <el-col :span="7">
          ID:{{instanceInfo.id}}
        </el-col>
        <el-col :span="9">
          服务名称:{{instanceInfo.name}}
        </el-col>
        <el-col :span="8">
          集成:{{instanceInfo.integrationVersionAlias}}
        </el-col>
        <el-col :span="7">
          模块类型:{{instanceInfo.moduleType}}
        </el-col>
        <el-col :span="9">
          模块版本:{{instanceInfo.moduleVersion}}
        </el-col>

        <el-col :span="8">
          设备名称:{{instanceInfo.deviceName}}
        </el-col>
      </el-row>
      <el-row>
        <el-form
          ref="formData"
          :model="formData"
          :rules="rules"
          label-width="190px"
        >
        <h3>模块类型</h3>
        <module-type-ele :tags="moduleTypes" @chooseTag="getModuleDepend"/>
        <h3>依赖模块</h3>
          <el-form-item class="item"
            v-for="(item, index) in formData.depends"
            :key="index"
            :label="item.name"
            :prop="item.required ? ('depends.'+index+'.selectedInstance') : ''"
            :rules="item.required ? {
                required: true, message: '至少选择一个实例', trigger: 'blur'
            } : {}"
          >
            <el-col :span="16">
              <el-select v-model="item.selectedInstance" multiple :multiple-limit="item.count">
                <el-option
                  v-for="(option, id) in item.instanceList"
                  :key="id"
                  :value="option.id"
                >
                  <span style="float: left">{{ option.name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">
                    {{ option.alias }}
                  </span>
                </el-option>
              </el-select>
            </el-col>

            <el-col :span="2" align="center">
              <i class="el-icon-circle-plus" @click="addInstance"></i>
            </el-col>
          </el-form-item>
        </el-form>
      </el-row>
      <el-row style="text-align:center;">
        <el-button type="primary" @click="saveConfirm">确定</el-button>
        <el-button @click="cancel()">取消</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import ModuleTypeEle from './ModuleTypeEle.vue'
export default {
  name: "Dependency",
  props: {
    visible: {
      type: Boolean
    },
    //类型，用于获取模块依赖
    module: {
      type: String
    },
    // 实例id，用于建立依赖关系
    instanceId: {
      type: [String, Number]
    },
    // 建立依赖还是编辑依赖 true:编辑 false:建立
    isEdit: {
      type: Boolean,
      default: false
    },
    // 如果targetModule不为空，则只显示targetModule
    targetModule: {
      type: String
    },
    instanceInfo:{
      type: Object,
      default: ()=>{
        return {}
      }
    }
  },
  components: { ModuleTypeEle },
  data: vm => ({
    formData: {
      // 依赖列表
      depends: [],
      // 选择的实例
      selectDepends: {}
    },
    rules: {},
    moduleTypes: []
  }),
  created() {
    // this.moduleTypes = [
    //   {
    //     name: 'Relay'
    //   },{
    //     name: 'BS'
    //   }
    // ]

    this.getModules()
    // 请求资源
    // this.getDepnds();
  },
  methods: {
    getModules(){
      if(this.module){
        this.moduleTypes = [{
          name: this.module,
          selected: true
        }];
        this.getModuleDepend(this.module);
        // if(this.isEdit){
        //   this.getInstanceDepned(this.instanceId)
        // }else{
        //   this.getModuleDepend(this.module)
        // }
        return
      }

      //网元模块类型可能是多个...
    },
    // 获取实例已有的依赖
    getInstanceDepned(instanceId){
      // let _this= this
      // this.formData.depends = []
      // this.$axios.get(this.baseUrl + 'instance/findAllDependency/' + instanceId)
      // .then(({data:{code, data, msg}}) => {
      //   if(code != 20000){
      //     this.$message.error('获取实例依赖失败')
      //   }else{
      //     if( data && Object.keys(data).length > 0){
      //       for(let key in data){
      //         if(data[key].length == 0){
      //           return
      //         }
      //         let obj = {
      //           id: data[key][0].id,
      //           name: key,
      //           selectedInstance: [],
      //           instanceList: [],
      //           required: data[key][0].required
      //         }
      //         let dependencyIdArr = []
      //         for(let item of data[key]){
      //           dependencyIdArr.push(item.dependencyId)
      //         }
      //         obj.selectedInstance = [...new Set(dependencyIdArr)]

      //         _this.formData.depends.push(obj)
      //       }

      //       if(_this.formData.depends.length > 0){
      //         _this.formData.depends.forEach((obj, index) => {
      //           _this.getInstanceList(obj.name, index)
      //         })
      //       }
      //     }else{
      //       this.$message.warning('实例的依赖为空')
      //     }
      //   }
      // })
      // .catch(err => {
      //   console.log(err)
      // })
      return new Promise((resolve, reject)=>{
        this.$axios.get(this.baseUrl3 + 'instance/findAllDependency/' + instanceId)
        .then(({data:{code, data, msg}})=>{
          if(code != 20000){
            let arr = {};
            reject(arr)
          }else{
            resolve(data)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 获取模块资源依赖
    getModuleDepend(moduleType){
      this.formData.depends = [];
      this.$axios.get(this.moduleResourceUrl + 'module/resource/get/dependency/'+moduleType)
      .then(async ({data:{code, data, msg}}) => {
        if(code != 20000){
          this.$message({
            message: msg
          })
        }else{
          let list = data.dependencies ? data.dependencies.dependencyList : [];
          if(list.length > 0){
            if(this.isEdit){
              let instanceDependency = await this.getInstanceDepned(this.instanceId);
              if(!instanceDependency || Object.keys(instanceDependency).length == 0){
                // this.$message.error('获取实例依赖失败')
                // return
                console.log('未获取到该实例原有的依赖')
              }else{
                for (let listItem of list) {
                  let arr = [];
                  let instanceDe = instanceDependency[listItem.module.name];
                  if (instanceDe && instanceDe.length > 0) {
                    for (let checkedInstance of instanceDependency[listItem.module.name]) {
                      arr.push(checkedInstance.dependencyId)
                    }
                    listItem.selectedInstance = arr
                  }
                }
              }
              // for(let listItem of list){
              //   let arr = []
              //   let instanceDe = instanceDependency[listItem.module.name]
              //   if(instanceDe && instanceDe.length > 0){
              //     for(let checkedInstance of instanceDependency[listItem.module.name]){
              //       arr.push(checkedInstance.dependencyId)
              //     }
              //     listItem.selectedInstance = arr
              //   }
              // }
              this.convertDepnds(list)
            }else{
              this.convertDepnds(list)
            }
          }else{
            this.$message({
              message: '没有相关依赖'
            })
          }
        }
      })
      .catch(err => {
        console.log(err)
      })
    },
    // 获取依赖列表
    convertDepnds(list) {
      let _this = this;
      list.forEach(obj => {
        /*
        * 如果模块不支持service-helper, 不需要查询service-agent的实例列表
        * modified by liuss on 2021-03-09
        * */
        if(!_this.instanceInfo.hasServiceHelper
          && obj.module.name.toLowerCase() == 'service_agent'){
          return
        }

        _this.formData.depends.push({
          id: obj.id,
          name: obj.module.name,
          selectedInstance: obj.selectedInstance ? obj.selectedInstance : [], //选择的实例
          instanceList: [],
          required: obj.required,
          count: obj.count,
          alias: obj.alias
        })
      });

      _this.formData.depends.forEach((obj, index) => {
        _this.getInstanceList(obj.name, index)
      });

      // 2020-05-14 被依赖查询时，只显示需要更新实例的模块
      if(this.targetModule){
        this.formData.depends = this.formData.depends.filter(d => d.name == this.targetModule)
      }
    },
    getInstanceList(name, idx){
      this.formData.depends[idx]['instanceList'] = [];
      if(!name){
        return
      }

      // add in 2021-03-09 by liuss
      let url = 'instance/findAllByModuleType/' + name;
      if(name == 'service_agent'){
        this.formData.depends[idx]['instanceList'].push({
          name: '实例'+ this.instanceInfo.device.serviceAgentId,
          id: this.instanceInfo.device.serviceAgentId
        })
        return
      }

      this.$axios.get(this.baseUrl3 + url)
      .then(({data:{code, data, msg}}) => {
        if(code != 20000){
          console.log('查找模块的实例列表失败：'+msg);
          if(name == 'service_agent'){
            this.$message.error(msg)
          }
        }else if (data && data.length > 0){
          data.forEach(obj => {
            this.formData.depends[idx]['instanceList'].push({
              name: obj.name ? obj.name : ('实例'+ obj.id),
              id: obj.id,
              alias: obj.alias
            })
          })
        }
      })
      .catch(err => {
        console.log(err)
      })
    },
    // 添加实例
    addInstance(){
      // 跳转到创建实例页面
      this.$router.push({
        path: "instancecreate",
        query: {
          p: "list"
        }
      });
      // 关闭弹框
      this.cancel()
    },
    cancel() {
      this.formData.moduleType = '';
      this.$emit("dependCallback", false);
    },
    save() {
        this.$refs['formData'].validate((valid) => {
          if (valid) {
              // this.$emit("dependCallback", this.formData.depends);
              let model = {
                id: this.instanceId,
                dependencies: []
              };
              this.formData.depends.forEach(obj => {
                    if(obj.selectedInstance){
                        obj.selectedInstance.forEach(select => {
                            model.dependencies.push(parseInt(select))
                        })
                    }
              });
              this.$axios.post(this.baseUrl3 + 'instance/saveDependency', model)
                .then(({ data: { msg, data, code } }) => {
                        if(code == 20000){
                            this.$message.success('操作成功');
                            // this.cancel()
                            this.formData.moduleType = '';
                            this.$emit("dependCallback", true);
                        }else{
                            this.$message({ showClose: true, message: msg, type: "error" });
                            console.log(msg);
                        }
                });
          } else {
            console.log('error submit!!');
            return false
          }
        });
    },

    saveConfirm(){
      if(!this.isEdit){
        this.save();
        return
      }
      this.$confirm('请确保该实例不处于启动状态', '提示', {
          confirmButtonText: '已确定，继续保存',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.save()
        }).catch(() => {
          this.cancel()
        });
    },
  }
};
</script>

<style scoped>
.depend >>> .el-dialog__body{
  padding-top: 0 !important;
}
.item >>> .el-select {
  width: 100%;
}
.item .el-icon-circle-plus {
  cursor: pointer;
}
</style>
